import styled from 'styled-components';
import { Modal } from 'antd';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledModal = styled(Modal)`
  &&& .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-between;
`;
export const StyledMessage = styled.div`
  ${pickThemeFontStyles('16', '18', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};
  align-self: flex-start;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  color: ${COLORS.GREY_DARK};
`;
